import { useState } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import { TbBellRinging2, TbRefresh, TbTicket } from "react-icons/tb";
import BrandMark from "../components/BrandMark";
import UserMenu from "../components/UserMenu";
import "./phone.css";
import {
  CraneOpenTickets,
  MyTickets,
  PhoneService,
  PhoneTicket,
  PickCrane,
  PickSection,
  QuickTicket,
  TechHome,
} from "./PhoneScreens";

function tabSelected(pathname, tab) {
  if (tab === "today") return pathname === "/m";
  if (tab === "cranes") return pathname.startsWith("/m/cranes") || pathname.startsWith("/m/service") || pathname.startsWith("/m/crane");
  if (tab === "tickets") return pathname.startsWith("/m/tickets") || pathname.startsWith("/m/ticket");
  return false;
}

export default function PhoneApp({
  isDarkMode,
  onToggleTheme,
  onLogout,
  onOffice,
  notifications = [],
  notifyCount = 0,
  onNotificationClick,
  onMarkAllRead,
  onRefreshNotifications,
}) {
  const history = useHistory();
  const location = useLocation();
  const showBack = location.pathname !== "/m";
  const [bellOpen, setBellOpen] = useState(false);
  const unread = notifications.filter((item) => item.read_status == 0);

  return (
    <div className="phone-shell">
      <header className="phone-header">
        <div>
          { showBack && (
            <button type="button" className="phone-back" onClick={ () => history.goBack() } aria-label="Back">
              ‹
            </button>
          ) }
          <span className="phone-brand">EPerion</span>
        </div>
        <div className="phone-header-tools">
          <button
            type="button"
            className="phone-bell"
            aria-label="Notifications"
            onClick={ () => setBellOpen((open) => !open) }
          >
            <TbBellRinging2 size={ 22 } />
            { notifyCount > 0 && (
              <span className="phone-bell-count">{ notifyCount > 99 ? "99+" : notifyCount }</span>
            ) }
          </button>
          <UserMenu
          isDarkMode={ isDarkMode }
          onToggleTheme={ onToggleTheme }
          onLogout={ onLogout }
          mode="technician"
          onSwitchMode={ onOffice }
          />
        </div>
      </header>
      { bellOpen && (
        <div className="phone-notify">
          <div className="phone-notify-actions">
            { unread.length > 0 && (
              <button type="button" onClick={ onMarkAllRead }>Mark all as read</button>
            ) }
            <button type="button" aria-label="Refresh notifications" onClick={ onRefreshNotifications }>
              <TbRefresh size={ 18 } />
            </button>
          </div>
          { unread.length === 0 && <p className="phone-muted">No unread notifications.</p> }
          { unread.map((item, index) => (
            <button
              type="button"
              className="phone-notify-item"
              key={ `${item.path}-${index}` }
              onClick={ () => {
                setBellOpen(false);
                if (onNotificationClick) onNotificationClick(item.path);
              } }
            >
              <strong>{ item.title }</strong>
              <span>{ item.body }</span>
            </button>
          )) }
        </div>
      ) }
      <main className="phone-main">
        <Switch>
          <Route exact path="/m/service/:craneId/:definitionId" component={ PhoneService } />
          <Route exact path="/m/service/:craneId" component={ PickSection } />
          <Route exact path="/m/service" render={ () => <PickCrane destination="service" /> } />
          <Route exact path="/m/crane/:craneId" component={ CraneOpenTickets } />
          <Route exact path="/m/cranes" render={ () => <PickCrane destination="crane" /> } />
          <Route exact path="/m/ticket/:ticketId" component={ PhoneTicket } />
          <Route exact path="/m/ticket" component={ QuickTicket } />
          <Route exact path="/m/tickets" component={ MyTickets } />
          <Route exact path="/m" component={ TechHome } />
        </Switch>
      </main>
      <nav className="phone-tabs">
        <button type="button" className={ `phone-tab${tabSelected(location.pathname, "today") ? " is-selected" : ""}` } onClick={ () => history.push("/m") }>
          <FaHome aria-hidden="true" />
          Today
        </button>
        <button type="button" className={ `phone-tab${tabSelected(location.pathname, "cranes") ? " is-selected" : ""}` } onClick={ () => history.push("/m/cranes") }>
          <BrandMark />
          Cranes
        </button>
        <button type="button" className={ `phone-tab${tabSelected(location.pathname, "tickets") ? " is-selected" : ""}` } onClick={ () => history.push("/m/tickets") }>
          <TbTicket aria-hidden="true" />
          Tickets
        </button>
      </nav>
    </div>
  );
}
